import { combineReducers } from 'redux';

import extensionsReducer from './extensions-reducer';
import centralSwitchWidgetsReducer from './CentralSwitchWidgetsReducer';
import chatsReducer from './chats-reducer';
import appReducer from './app-reducer';
import pbxReducer from './pbx-reducer';
import channelsReducer from './channels-reducer';
import contactsReducer from './contacts-reducer';
import profileReducer from './profile-reducer';
import openGraphReducer from './open-graph-reducer';
import customersReducer from './customers-reducer';
import voicemailsReducer from './voicemails-reducer';
import topReducer from './top-reducer';
import socialIntegrationReducer from './social-integration-reducer';
import integrationAccessReducer from './integration-access-reducer';
import phoneReducer from './phone-reducer';
import soundsReducer from './sounds-reducer';
import callRoutingsReducer from './call-routings-reducer';
import meetingReducer from './meeting-reducer';
import videoReducer from './video-reducer';
import headsetReducer from './headset-reducer';
import favoritesReducer from './favorites-reducer';
import ringtoneReducer from './ringtone-reducer';
import retailerReducer from './retailer-reducer';
import userCredentialsReducer from './user-credentials-reducer';
import wallboardsReducer from './wallboards-reducer';
import ctiReducer from './cti-reducer';
import callRecordsReducer from './call-records-reducer';
import licenseReducer from './license-reducer';
import omnichannelReducer from './omnichannel-reducer';
import callWidgetReducer from './call-widget-reducer';
import operatorReducer from './operator-reducer';
import supervisorReducer from './SupervisorReducer';
import ticketsReducer from './tickets-reducer';
import featureFlagsReducer from './featureflags-reducer';
import { video2Reducer } from './video2-reducer';
import videoChatReducer from './video-chat-reducer';
import keyboardShortcutsReducer from './keyboard-shortcuts-reducer';
import { recordedCallsReducer } from './RecordedCallsReducer';

const createRootReducer = () =>
    combineReducers({
        extensions: extensionsReducer,
        centralSwitchWidgets: centralSwitchWidgetsReducer,
        contacts: contactsReducer,
        chats: chatsReducer,
        app: appReducer,
        pbx: pbxReducer,
        channels: channelsReducer,
        profiles: profileReducer,
        openGraph: openGraphReducer,
        customer: customersReducer,
        voicemail: voicemailsReducer,
        top: topReducer,
        socialIntegration: socialIntegrationReducer,
        integrationAccess: integrationAccessReducer,
        phone: phoneReducer,
        sounds: soundsReducer,
        callRoutings: callRoutingsReducer,
        meeting: meetingReducer,
        video: videoReducer,
        headsets: headsetReducer,
        favorites: favoritesReducer,
        ringtones: ringtoneReducer,
        retailer: retailerReducer,
        userCredentials: userCredentialsReducer,
        wallboards: wallboardsReducer,
        integration: ctiReducer,
        callRecordsData: callRecordsReducer,
        licenses: licenseReducer,
        omnichannel: omnichannelReducer,
        callWidgets: callWidgetReducer,
        operator: operatorReducer,
        supervisor: supervisorReducer,
        tickets: ticketsReducer,
        featureFlags: featureFlagsReducer,
        video2: video2Reducer,
        videoChat: videoChatReducer,
        keyboardShortcuts: keyboardShortcutsReducer,
        recordedCalls: recordedCallsReducer,
    });

export default createRootReducer;
